import "./controllers";
import "@hotwired/turbo-rails";
// eslint-disable-next-line no-undef
Turbo.session.drive = false;
